import thirdPartyManager from '../managers/ThirdPartyManager';
import userManager from '../managers/UserManager';

import { registerClass } from '../SatCoreRegistry';

export default class ThirdPartyService {
  static shouldAllowThirdPartyChatLauncherForActiveUser = () => {
    const allowedChatUserRoles = thirdPartyManager.allowedThirdPartyChatLauncherUserRoles;
    return allowedChatUserRoles?.includes?.(userManager.activePermissionId);
  }

  static removeThirdPartyChatLauncherIfApplicable = ({ alsoRegenerateChatLauncherId = false } = {}) => {
    const zohoChatElement = document.getElementById('zohohc-asap-web-helper-main');
    if (zohoChatElement) {
      zohoChatElement.remove();
      if (alsoRegenerateChatLauncherId) {
        thirdPartyManager.regenerateThirdPartyChatLauncherId();
      }
    }
  }
}

registerClass('ThirdPartyService', ThirdPartyService);
